import { openAtom } from "@mongez/react-atom";

export const headerMenuAtom = openAtom("headerMenu");
